// Single source of truth for the 41 backend `@PermissionKey` strings from
// GET /university-admin/me/permissions. Mirrors the table in
// university-admin-permission-frontend-guide.md — keep in sync if the backend
// adds new keys. Call sites should always reference these constants rather
// than hardcoding raw strings, to avoid silent typos that would fail closed.
export const PERMISSIONS = {
  auditLog: {
    list: "auditLog:list",
  },
  campus: {
    list: "campus:list",
    get: "campus:get",
    create: "campus:create",
    update: "campus:update",
    delete: "campus:delete",
  },
  club: {
    list: "club:list",
    get: "club:get",
    create: "club:create",
    update: "club:update",
    delete: "club:delete",
    members: "club:members",
    membersExport: "club:members-export",
    statistics: "club:statistics",
    statisticsExport: "club:statistics-export",
    listExport: "club:list-export",
  },
  department: {
    list: "department:list",
    get: "department:get",
    create: "department:create",
    update: "department:update",
    delete: "department:delete",
  },
  event: {
    list: "event:list",
    get: "event:get",
    create: "event:create",
    update: "event:update",
    cancel: "event:cancel",
    approve: "event:approve",
    reject: "event:reject",
    delete: "event:delete",
    attendantList: "event:attendant:list",
    attendantAdd: "event:attendant:add",
    attendantRemove: "event:attendant:remove",
    statistics: "event:statistics",
    statisticsExport: "event:statistics-export",
    participants: "event:participants",
    participantsExport: "event:participants-export",
    ticketOwners: "event:ticket-owners",
    ticketOwnersExport: "event:ticket-owners-export",
  },
  faculty: {
    list: "faculty:list",
    get: "faculty:get",
    create: "faculty:create",
    update: "faculty:update",
    delete: "faculty:delete",
  },
  // Club-scoped: also requires allClubsAccess or the club's id in clubScopeIds.
  membership: {
    assignRole: "membership:assignRole",
    revokeRole: "membership:revokeRole",
    listElevated: "membership:listElevated",
  },
  university: {
    get: "university:get",
    updateLoginPolicy: "university:updateLoginPolicy",
    updateLogo: "university:updateLogo",
  },
  user: {
    list: "user:list",
    get: "user:get",
    toggleActive: "user:toggleActive",
    toggleBan: "user:toggleBan",
  },
  analytics: {
    view: "analytics:view",
    events: "analytics:events",
    export: "analytics:export",
  },
  transaction: {
    list: "transaction:list",
    get: "transaction:get",
    approve: "transaction:approve",
    reject: "transaction:reject",
    refund: "transaction:refund",
  },
};

export const CLUB_SCOPED_KEYS = new Set([
  PERMISSIONS.membership.assignRole,
  PERMISSIONS.membership.revokeRole,
  PERMISSIONS.membership.listElevated,
]);
